'use client';

import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import NavigationLinks from './NavigationLinks';

export default function FeedbackConfirmation() {
	return (
		<div className="w-full">
			{/* Header */}
			<div className="w-full bg-blue-dark py-10 md:py-14">
				<div className="max-w-7xl mx-auto px-6 text-center">
					<motion.div
						initial={{ scale: 0.5, opacity: 0 }}
						animate={{ scale: 1, opacity: 1 }}
						transition={{ duration: 0.5, type: 'spring' }}
						className="flex justify-center mb-5"
					>
						<div className="bg-seaweed/30 p-4 rounded-full backdrop-blur-sm">
							<CheckCircle className="size-14 md:size-16 text-white" />
						</div>
					</motion.div>
					<h2 className="text-3xl md:text-4xl font-bold font-heading text-white mb-4">
						Bedankt voor uw feedback!
					</h2>
					<p className="text-blue-100 text-lg md:text-xl max-w-lg mx-auto leading-relaxed">
						Uw mening helpt ons om onze service te verbeteren.
					</p>
				</div>
			</div>

			{/* Navigation */}
			<NavigationLinks />
		</div>
	);
}
